module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_7042.b8e1778e.png";